import { render } from "./MenuAdmin.vue?vue&type=template&id=0b2d0aef&scoped=true"
import script from "./MenuAdmin.vue?vue&type=script&lang=js"
export * from "./MenuAdmin.vue?vue&type=script&lang=js"

import "./MenuAdmin.vue?vue&type=style&index=0&id=0b2d0aef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2d0aef"]])

export default __exports__